import { useMutation } from "@tanstack/react-query";

import { ApiClient } from "../api-client";

export const useRegisterGuardian = () => {
  return useMutation({
    mutationFn: async ({ guardianToken }: { guardianToken: string; userId?: string }) => {
      const response = await ApiClient.api.purchaseControllerRegisterGuardian({
        guardianToken,
      });

      return response.data;
    },
  });
};
